 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"cab8aa87e8b2077671e9169c4d00d4feb9719395","3":"9c5ba0a544797207048daebc5bbaebf562e2f0bc","4":"da274b67b03263e520f7b918400255be5259cbc4","5":"b9390e6aecf2b5cb0f159fd5482310f090c8dfbf","6":"ea88be26","7":"7c5ead21e5908f6f25786a511bc70f58e243c1f8","8":"89bf253321d9d06c8d43d13a84e5ff385058f826","9":"c3fdd2811d12102e64c3d61404acd2dc774a5c8c","10":"0ce3d59369355c8ceb5f0b6851976426d6e0a0d7","11":"1fe38f8b2c6ac76250641bb343cb2acacb47860c","12":"7723483330c604f709063740994781512be65870","13":"a1fda6617e25b9837fea1bf683b2d8ad818416f8","14":"fa9fe86e28d2e8d761e1503e2765752a859afffd","17":"component---src-pages-404-js","18":"component---src-pages-about-index-js","19":"component---src-pages-contact-js","20":"component---src-pages-index-js","21":"component---src-pages-notification-js","22":"component---src-pages-portfolio-index-js","23":"component---src-pages-portfolio-map-js","24":"component---src-pages-privacy-js","25":"component---src-pages-terms-js","26":"component---src-pages-under-construction-js","27":"component---src-pages-unsubscribe-js","28":"component---src-templates-project-gallery-js","29":"component---src-templates-project-location-js","30":"component---src-templates-project-private-material-js","31":"component---src-templates-project-progress-js","32":"component---src-templates-project-snapshot-js","33":"component---src-templates-project-vision-js","36":"reactPlayerDailyMotion","37":"reactPlayerFacebook","38":"reactPlayerFilePlayer","39":"reactPlayerKaltura","40":"reactPlayerMixcloud","41":"reactPlayerMux","42":"reactPlayerPreview","43":"reactPlayerSoundCloud","44":"reactPlayerStreamable","45":"reactPlayerTwitch","46":"reactPlayerVidyard","47":"reactPlayerVimeo","48":"reactPlayerWistia","49":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"013dbb1299be5da82241","1":"e9d24b1846c7d6eb9685","2":"5f49593d855590b216d9","3":"3097968cbe4d475cb687","4":"2da76c67b93ded449461","5":"62d4ff595a5567929f9b","6":"f9a6dbf4bb4b2c4a3255","7":"bfedd5b43acf798bab2f","8":"1d7ef792e912ecf03c94","9":"d08e351eba6a35af96c4","10":"24f1333d123127518bee","11":"0313155486c147849571","12":"cb19d125f2556417d6b8","13":"5b88e60341d5b2058f8a","14":"b4b5c53e5b5b888b7a6e","17":"b006c20fbc6429199960","18":"9663333c86d9c19ed4fb","19":"e3684fd3753ef471ae16","20":"23c247205ae0e4c16a9c","21":"fd2bf1360882e2f3f3fe","22":"3baf3269ecddae1b06d8","23":"97b628c640df30442ecb","24":"f1a435da20e17a84cc6c","25":"f80d911bcef46016c848","26":"6f63f3528773baa8a86f","27":"2f745ddd694b370cb500","28":"d19985052b8103550efe","29":"0c277bd5f4cf404a82f2","30":"7818ddc7a30e34421f6d","31":"e6828dc5ecac4b708d5d","32":"fca60a68d891e7a1684f","33":"e80d97aa5103a6a690d6","36":"d58a1c0ac7ac7910936c","37":"2e762ce6a06ace3e3a88","38":"2be4cafd34822a086ca3","39":"dd362d564bb85b6c69ea","40":"799f0f5d6bc52a61871e","41":"bed847de0b5c63158f99","42":"e5bbfcfd2b34115c1c96","43":"3483cc0438aee7cb8734","44":"976edbb5ec7a027fa9a8","45":"92b37d187ea8e9911ded","46":"5c868299408c4bc105e3","47":"355d695d405994cdd3f6","48":"42902722895a08afa619","49":"1c9221ce3041a424e121","50":"f266789f70b4bb017df9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"cab8aa87e8b2077671e9169c4d00d4feb9719395","3":"9c5ba0a544797207048daebc5bbaebf562e2f0bc","4":"da274b67b03263e520f7b918400255be5259cbc4","5":"b9390e6aecf2b5cb0f159fd5482310f090c8dfbf","6":"ea88be26","7":"7c5ead21e5908f6f25786a511bc70f58e243c1f8","8":"89bf253321d9d06c8d43d13a84e5ff385058f826","9":"c3fdd2811d12102e64c3d61404acd2dc774a5c8c","10":"0ce3d59369355c8ceb5f0b6851976426d6e0a0d7","11":"1fe38f8b2c6ac76250641bb343cb2acacb47860c","12":"7723483330c604f709063740994781512be65870","13":"a1fda6617e25b9837fea1bf683b2d8ad818416f8","14":"fa9fe86e28d2e8d761e1503e2765752a859afffd","17":"component---src-pages-404-js","18":"component---src-pages-about-index-js","19":"component---src-pages-contact-js","20":"component---src-pages-index-js","21":"component---src-pages-notification-js","22":"component---src-pages-portfolio-index-js","23":"component---src-pages-portfolio-map-js","24":"component---src-pages-privacy-js","25":"component---src-pages-terms-js","26":"component---src-pages-under-construction-js","27":"component---src-pages-unsubscribe-js","28":"component---src-templates-project-gallery-js","29":"component---src-templates-project-location-js","30":"component---src-templates-project-private-material-js","31":"component---src-templates-project-progress-js","32":"component---src-templates-project-snapshot-js","33":"component---src-templates-project-vision-js","36":"reactPlayerDailyMotion","37":"reactPlayerFacebook","38":"reactPlayerFilePlayer","39":"reactPlayerKaltura","40":"reactPlayerMixcloud","41":"reactPlayerMux","42":"reactPlayerPreview","43":"reactPlayerSoundCloud","44":"reactPlayerStreamable","45":"reactPlayerTwitch","46":"reactPlayerVidyard","47":"reactPlayerVimeo","48":"reactPlayerWistia","49":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"f8db44c44944f0992a24","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
